import { useTranslate } from '@/core/locales';
import { TRANSLATION_NAMESPACES } from '@/core/constants';

import { Iconify } from '@/components/iconify';
import { Button, IconButton } from '@/components/ui';

import { paths } from '@/routes/paths';
import { RouterLink } from '@/routes/components';

interface SignInButtonProps {
  isSmall?: boolean;
  [key: string]: any;
}

export function SignInButton({ isSmall = false, ...other }: SignInButtonProps) {
  const { t } = useTranslate(TRANSLATION_NAMESPACES.AUTH);

  return (
    <>
      <IconButton
        size="large"
        color="primary"
        component={RouterLink}
        href={paths.auth.singIn}
        className={`${isSmall ? '' : 'inline-flex lg:hidden'}`}
        {...other}
      >
        <Iconify icon="lucide:circle-user" width={30} className="text-primary" />
      </IconButton>

      {!isSmall && (
        <Button
          component={RouterLink}
          href={paths.auth.singIn}
          variant="contained"
          className="hidden lg:inline-flex"
          {...other}
        >
          {t('signIn')}
          <Iconify icon="lucide:circle-user" className="text-white ml-1" />
        </Button>
      )}
    </>
  );
}
